export const SITE = {
  name: "Scharpf",
  fullName: "Scharpf Haushaltsauflösungen & Entrümpelungen",
  familyName: "Familie Scharpf",
  phone: "01726768531",
  phoneDisplay: "0172 676 8531",
  phoneE164: "+4901726768531",
  whatsapp: "4901726768531",
  email: "scharpfhaushaltsaufloesung@gmail.com",
  contactPerson: "Kevin Scharpf",
  city: "Oberhausen",
  region: "Oberhausen und Umgebung",
  address: "Oskarstraße 65, 46145 Oberhausen",
  addressStreet: "Oskarstraße 65",
  addressCity: "46145 Oberhausen",
  serviceAreas: [
    "Oberhausen",
    "Bottrop",
    "Essen",
    "Mülheim a. d. Ruhr",
    "Duisburg",
    "Gelsenkirchen",
    "Herten",
    "Gladbeck",
    "Dorsten",
    "Marl",
    "Dinslaken",
    "Voerde",
    "Recklinghausen",
  ],
  serviceAreaNote: "Düsseldorf nach Absprache · weitere Bereiche auf Anfrage und nach telefonischer Absprache",
  logo: "https://customer-assets.emergentagent.com/job_scharpf-goldankauf/artifacts/dvs0afil_IMG_0973.jpeg",
  vehicle: "https://customer-assets.emergentagent.com/job_scharpf-goldankauf/artifacts/1muwuc6h_2ed909d4-ab85-4ecb-82ac-6602471b2a24.jpeg",
};

export const NAV_LINKS = [
  { label: "Leistungen", href: "#leistungen" },
  { label: "Vorher / Nachher", href: "#vorher-nachher" },
  { label: "Über uns", href: "#ueber-uns" },
  { label: "Goldankauf", href: "#service-goldankauf" },
  { label: "Kontakt", href: "#kontakt" },
];

export const SERVICES = [
  {
    id: "haushaltsaufloesungen",
    title: "Haushaltsauflösungen & Entrümpelungen in Oberhausen",
    short: "Haushaltsauflösung",
    kicker: "Diskret · Schnell · Professionell",
    paragraphs: [
      "Sie planen eine Haushaltsauflösung oder Entrümpelung in Oberhausen und suchen einen zuverlässigen Partner? Wir bieten Ihnen einen umfassenden Service – diskret, schnell und professionell.",
      "Ob komplette Haushaltsauflösung, Entrümpelung von Wohnungen oder Gewerbeeinheiten – wir übernehmen den gesamten Prozess für Sie. Dabei sorgen wir für eine transparente und faire Abwicklung: Von der kostenlosen Besichtigung über die Wertanrechnung verwertbarer Gegenstände bis hin zur fachgerechten Entsorgung.",
      "Unser Ziel ist es, Ihnen eine stressfreie und verlässliche Lösung zu bieten. Mit klaren Festpreisen, ohne versteckte Kosten, und einer pünktlichen, besenreinen Übergabe Ihrer Immobilie. Kontaktieren Sie uns für eine persönliche Beratung und ein individuelles Angebot.",
    ],
    bullets: [
      "Kostenlose Vor-Ort-Besichtigung",
      "Festpreis-Garantie ohne versteckte Kosten",
      "Wertanrechnung möglich",
      "Besenreine Übergabe inklusive",
    ],
    images: [
      "https://images.unsplash.com/photo-1630699375895-fe5996d163ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1625585598750-3535fe40efb3?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.unsplash.com/photo-1493809842364-78817add7ffb?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    ],
  },
  {
    id: "entruempelungen",
    title: "Entrümpelungen in NRW – Schnell, diskret und zuverlässig",
    short: "Entrümpelung",
    kicker: "Wohnung, Keller, Dachboden, Garage & Gewerbe",
    paragraphs: [
      "Wenn es Zeit wird, Platz zu schaffen, sind wir Ihr zuverlässiger Partner in Oberhausen und Umgebung. Wir übernehmen professionelle Entrümpelungen von Wohnungen, Häusern, Kellern, Garagen, Dachböden und Gewerbeobjekten – schnell, effizient und mit großer Sorgfalt.",
      "Mit unserem eigenen Fuhrpark und einem erfahrenen Team kümmern wir uns um den gesamten Ablauf. Wir trennen Wertstoffe fachgerecht, entsorgen alle Materialien umweltgerecht und halten vereinbarte Termine zuverlässig ein.",
      "Jede Entrümpelung betrachten wir individuell. Wir besprechen Ihre Wünsche ausführlich, arbeiten diskret und respektvoll und passen uns flexibel an Ihre Anforderungen an. Unser Ziel ist es, Ihnen die Arbeit und den Stress abzunehmen, damit Sie sich auf das Wesentliche konzentrieren können.",
    ],
    bullets: [
      "Eigener Fuhrpark & erfahrenes Team",
      "Fachgerechte Wertstoff-Trennung",
      "Umweltgerechte Entsorgung",
      "Zuverlässige Terminplanung",
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_scharpf-goldankauf/artifacts/664jrht0_7B91F149-382D-45CD-BE47-B8D0DF3DDA72.png",
      "https://customer-assets.emergentagent.com/job_scharpf-goldankauf/artifacts/x07rf7eh_5193FB2E-D660-4BF2-906A-B79693D26BD6.png",
      "https://customer-assets.emergentagent.com/job_scharpf-goldankauf/artifacts/ocyi04l2_FC90D791-5FAB-4476-BBD2-51294381CB01.png",
    ],
  },
  {
    id: "messie-raeumungen",
    title: "Messie-Räumungen & Spezialräumungen",
    short: "Messie- / Spezialräumung",
    kicker: "Diskret · Respektvoll · Ohne Vorurteile",
    paragraphs: [
      "Besondere Situationen erfordern Fingerspitzengefühl, Erfahrung und Diskretion. Wir unterstützen Sie bei Messie-Räumungen und Spezialräumungen zuverlässig, professionell und ohne Vorurteile. Dabei behandeln wir jede Situation mit Respekt und gehen individuell auf Ihre Bedürfnisse ein.",
      "Ob stark verwahrloste Wohnungen, Häuser, Keller oder andere anspruchsvolle Objekte – unser erfahrenes Team übernimmt die komplette Räumung schnell, diskret und fachgerecht. Auf Wunsch kümmern wir uns zusätzlich um die Endreinigung, sodass die Räumlichkeiten besenrein übergeben werden können.",
      "Unser Ziel ist es, Ihnen in schwierigen Situationen eine spürbare Entlastung zu bieten und den gesamten Ablauf so unkompliziert und stressfrei wie möglich zu gestalten.",
    ],
    bullets: [
      "100 % diskret & vertraulich",
      "Auch stark verwahrloste Objekte",
      "Endreinigung auf Wunsch",
      "Respektvolles, individuelles Vorgehen",
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_scharpf-goldankauf/artifacts/r1io36nc_IMG_2610.jpeg",
      "https://customer-assets.emergentagent.com/job_scharpf-goldankauf/artifacts/3jlvivvx_IMG_2595.jpeg",
      "https://customer-assets.emergentagent.com/job_scharpf-goldankauf/artifacts/schdkm7w_IMG_2607.jpeg",
    ],
  },
  {
    id: "nachlass-ankauf",
    title: "Nachlassankauf in Oberhausen",
    short: "Nachlassankauf",
    kicker: "Faire Bewertung Ihrer Gegenstände",
    paragraphs: [
      "Sie möchten einen Nachlass auflösen oder wertvolle Gegenstände aus einer Erbschaft verkaufen? Wir sind Ihr kompetenter Ansprechpartner für den Ankauf von Nachlässen in Oberhausen und Umgebung. Ob einzelne Wertgegenstände oder komplette Nachlässe – wir bewerten Ihre Gegenstände fair, transparent und marktgerecht.",
      "Wir kaufen unter anderem Antiquitäten, Schmuck, Gold, Silber, Münzen, Uhren, Porzellan sowie hochwertige Möbel und andere wertvolle Gegenstände an. Auf Wunsch übernehmen wir auch die komplette Nachlassabwicklung inklusive Haushaltsauflösung und Entrümpelung.",
      "Unser erfahrenes Team steht Ihnen in dieser oft emotionalen Situation mit Vertraulichkeit und Einfühlungsvermögen zur Seite. Nach einer unverbindlichen Besichtigung erhalten Sie ein faires Angebot und eine schnelle, unkomplizierte Abwicklung.",
    ],
    bullets: [
      "Antiquitäten, Schmuck, Gold, Silber",
      "Uhren, Porzellan, Möbel",
      "Komplette Nachlassabwicklung möglich",
      "Vertrauliche & einfühlsame Beratung",
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_scharpf-goldankauf/artifacts/dzz9p4ku_IMG_0982.jpeg",
      "https://customer-assets.emergentagent.com/job_scharpf-goldankauf/artifacts/kn7z969q_IMG_0981.jpeg",
      "https://images.unsplash.com/photo-1567016376408-0226e4d0c1ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    ],
  },
  {
    id: "goldankauf",
    title: "Gold-, Schmuck- & Edelmetallankauf",
    short: "Gold-, Schmuck- & Edelmetallankauf",
    kicker: "24/7 für Sie erreichbar – Persönlich, fair und direkt bei Ihnen zu Hause",
    paragraphs: [
      "Der Verkauf von Gold und Wertgegenständen ist Vertrauenssache. Deshalb setzen wir auf persönlichen Service und eine transparente Beratung. Hausbesuche werden persönlich von Kevin Scharpf (Inhaber) durchgeführt, damit Sie sich auf eine seriöse, diskrete und professionelle Abwicklung verlassen können.",
      "Wir kaufen Gold, Schmuck, Silber, Münzen, Zahngold, Altgold, Silberbesteck sowie andere Edelmetalle zu fairen und marktgerechten Preisen und aktuellen Tageskursen an. Ob einzelne Wertgegenstände, Erbschaften oder komplette Sammlungen – wir nehmen uns Zeit für eine sorgfältige Bewertung und erstellen Ihnen ein unverbindliches Angebot.",
      "Mit unserem 24/7-Service sind wir jederzeit für Sie erreichbar und bieten Ihnen flexible Termine – auch abends und am Wochenende. Sie müssen keine langen Wege auf sich nehmen, denn wir kommen direkt zu Ihnen nach Hause und beraten Sie persönlich in vertrauter Umgebung. Wenn es zu einem Geschäft kommt, werden Ausweis und Dokumente gespeichert und Sie erhalten am gleichen Tag noch das Geld.",
    ],
    bullets: [
      "Gold, Schmuck, Silber, Münzen, Zahngold",
      "Persönlicher Hausbesuch (Kevin Scharpf)",
      "Tagesaktuelle Bestpreise",
      "24/7 Service · auch abends & am Wochenende",
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_scharpf-goldankauf/artifacts/mrv5dwjo_IMG_0986.jpeg",
      "https://customer-assets.emergentagent.com/job_scharpf-goldankauf/artifacts/q6dzco10_IMG_0984.jpeg",
      "https://images.unsplash.com/photo-1586974710160-55f48f417990?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    ],
    process: [
      {
        step: "1",
        title: "Termin vereinbaren",
        text:
          "Sie rufen uns kurz an oder schreiben per WhatsApp. Wir sind 24/7 erreichbar und verabreden einen Termin – auf Wunsch noch am selben Tag bei Ihnen zuhause, auch abends oder am Wochenende.",
      },
      {
        step: "2",
        title: "Persönliches Vorbeikommen",
        text:
          "Kevin Scharpf kommt persönlich, diskret und ohne Druck zu Ihnen. Vor Ihren Augen werden Ihre Stücke gesichtet, geordnet und vorbereitet – Sie behalten alles jederzeit im Blick.",
      },
      {
        step: "3",
        title: "Echtheitsprüfung",
        text:
          "Mit Prüfstein, Säure-Test und Magnet wird die Echtheit Ihres Goldes oder Silbers geprüft. So sehen Sie selbst, ob ein Stück wirklich aus Edelmetall ist und welche Legierung (z. B. 333, 585, 750, 916, 999) es hat.",
      },
      {
        step: "4",
        title: "Wiegen auf geeichter Feinwaage",
        text:
          "Jedes Stück wird einzeln auf einer geeichten Feinwaage gewogen. Sie sehen das Gewicht selbst auf dem Display – nichts geschieht im Verborgenen.",
      },
      {
        step: "5",
        title: "Tagesaktueller Preis",
        text:
          "Anhand des aktuellen Tageskurses und der ermittelten Legierung errechnen wir Ihnen den Ankaufspreis transparent. Sie entscheiden in Ruhe, ob Sie verkaufen möchten – ohne Verpflichtung.",
      },
      {
        step: "6",
        title: "Auszahlung am gleichen Tag",
        text:
          "Wenn es zu einem Geschäft kommt, werden Ausweis und Dokumente kurz erfasst und Sie erhalten Ihr Geld noch am selben Tag – dazu einen schriftlichen Ankaufsbeleg.",
      },
    ],
  },
];

export const ABOUT_TEXT = {
  eyebrow: "Über uns · Scharpf Haushaltsauflösungen & Entrümpelungen",
  heading1: "Persönlich. Kompetent.",
  heading2: "Zuverlässig.",
  intro:
    "Ihr zuverlässiger Partner für Haushaltsauflösungen, Entrümpelungen und Nachlassankäufe in Oberhausen und Umgebung.",
  paragraphs: [
    "Bei Scharpf Haushaltsauflösungen & Entrümpelungen stehen Vertrauen, Zuverlässigkeit und persönliche Betreuung an erster Stelle. Als inhabergeführtes Unternehmen haben wir es uns zur Aufgabe gemacht, unsere Kunden in besonderen Lebenssituationen professionell zu unterstützen und ihnen die damit verbundenen Belastungen abzunehmen.",
    "Ob Haushaltsauflösung, Entrümpelung, Nachlassabwicklung oder Wertankauf – wir bieten Ihnen einen umfassenden Service aus einer Hand. Dabei legen wir größten Wert auf eine saubere, termingerechte und transparente Arbeitsweise. Jede Räumung wird individuell geplant und mit größter Sorgfalt durchgeführt – von der ersten Besichtigung bis zur besenreinen Übergabe.",
    "Unter der Leitung von Kevin Scharpf (Inhaber) setzen wir auf persönlichen Kontakt und maßgeschneiderte Lösungen. Wir wissen, dass hinter jeder Haushaltsauflösung und Entrümpelung eine persönliche Geschichte steht. Deshalb begegnen wir unseren Kunden stets mit Respekt, Verständnis und einem hohen Maß an Professionalität.",
    "Dank unseres erfahrenen Teams und unseres eigenen Fuhrparks sind wir in der Lage, sowohl kleine als auch große Projekte schnell und zuverlässig umzusetzen. Wir übernehmen Entrümpelungen von Wohnungen, Häusern, Kellern, Garagen, Dachböden und Gewerbeobjekten sowie komplette Haushalts- und Wohnungsauflösungen.",
    "Darüber hinaus sind wir Ihr kompetenter Ansprechpartner für Nachlassankäufe sowie den Ankauf von Gold, Schmuck, Silber, Münzen, Zahngold, Altgold, Silberbesteck und anderen Edelmetallen. Durch faire Bewertungen und transparente Angebote bieten wir unseren Kunden eine unkomplizierte und vertrauensvolle Abwicklung.",
  ],
  reasons: [
    "Persönliche Betreuung durch Kevin Scharpf (Inhaber)",
    "Kostenlose und unverbindliche Besichtigungen",
    "Faire und transparente Festpreise",
    "Zuverlässige und termingerechte Durchführung",
    "Eigener Fuhrpark und erfahrenes Team",
    "Diskrete und respektvolle Arbeitsweise",
    "Haushaltsauflösungen, Entrümpelungen & Ankäufe aus einer Hand",
    "24/7 erreichbar – jederzeit für unsere Kunden da",
  ],
  outro:
    "Unser Anspruch ist es, Ihnen nicht nur Arbeit abzunehmen, sondern Ihnen in einer oft herausfordernden Situation als zuverlässiger Partner zur Seite zu stehen. Mit Erfahrung, Engagement und Leidenschaft sorgen wir dafür, dass jede Aufgabe professionell und zu Ihrer vollsten Zufriedenheit erledigt wird.",
  claim: "Persönlich. Kompetent. Zuverlässig. – Ihr Partner für professionelle Räumungen und faire Ankäufe in Oberhausen und Umgebung.",
};
